import { useEffect } from "react";
import { initalAppConfig } from "../system/initial/appConfig";
import { appConfig } from "../system/types/app/appConfig";
import { dispatch } from "../App";
import { actions } from "../redux";

const useEnv = () => {

    useEffect(() => {
        const appConfig:appConfig = initalAppConfig;

        appConfig.apiKey = process.env.REACT_APP_API_KEY ?? '';
        appConfig.apiUrl = process.env.REACT_APP_API_URL ?? '';
        appConfig.language = process.env.REACT_APP_DEFAULT_LANGUAGE ?? '';

        dispatch(actions.system.setAppConfig(appConfig));

    }, []);
};

export { useEnv };
